import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ThumbsUp, MessageCircle, Share2, ChevronDown } from 'lucide-react';
interface Comment {
  name: string;
  photo: string;
  text: string;
  time: string;
  likes?: number;
  replies?: {
    name: string;
    photo: string;
    text: string;
    time: string;
    likes?: number;
  }[];
}
const comments: Comment[] = [{
  name: 'María José Herrera',
  photo: 'https://randomuser.me/api/portraits/women/12.jpg',
  text: 'VENDÍ MI PRIMER PDF!! 😭😭😭 no lo puedo creer, fueron $15 dólares pero se sintieron como un millón. Mi esposo no me creía cuando le enseñé el comprobante jajaja',
  time: '2h',
  likes: 47,
  replies: [{
    name: 'Valentina Ríos',
    photo: 'https://randomuser.me/api/portraits/women/28.jpg',
    text: 'Felicidades amiga!! 🎉🎉 yo voy en el día 4, ya casi termino el mío',
    time: '1h',
    likes: 8
  }]
}, {
  name: 'Camila Rodríguez',
  photo: 'https://randomuser.me/api/portraits/women/33.jpg',
  text: 'Lo hice mientras mi bebé dormía la siesta 😂 literal en ratitos y ya tengo mi PDF listo. Mañana lo publico en mis estados!!',
  time: '3h',
  likes: 34
}, {
  name: 'Sofía Martínez',
  photo: 'https://randomuser.me/api/portraits/women/45.jpg',
  text: 'Lo amééé 💕💕💕',
  time: '4h',
  likes: 21
}, {
  name: 'Isabella Vargas',
  photo: 'https://randomuser.me/api/portraits/women/51.jpg',
  text: 'Publiqué en mis estados de WhatsApp y ya me escribieron 4 personas preguntando precio 🤯 y eso que apenas lo subí hace 2 horas. Esto funciona de verdad',
  time: '5h',
  likes: 56,
  replies: [{
    name: 'Luciana Mendoza',
    photo: 'https://randomuser.me/api/portraits/women/19.jpg',
    text: 'Amigaaa pasame tips!! yo todavia no me animo a publicar 😅',
    time: '4h',
    likes: 3
  }, {
    name: 'Isabella Vargas',
    photo: 'https://randomuser.me/api/portraits/women/51.jpg',
    text: '@Luciana solo hazlo! yo tambien tenia pena pero la guía te dice exactamente qué poner',
    time: '3h',
    likes: 12
  }]
}, {
  name: 'Daniela Flores',
  photo: 'https://randomuser.me/api/portraits/women/63.jpg',
  text: 'Gracias por esto, de verdad necesitaba algo así de simple. Llevo meses queriendo empezar algo y siempre me trababa. Con esto por fin entendí qué hacer',
  time: '5h',
  likes: 29
}, {
  name: 'Fernanda López',
  photo: 'https://randomuser.me/api/portraits/women/72.jpg',
  text: 'Día 3 y ya tengo mi PDF listo 🙌 mañana armo la oferta y el viernes publico. No puedo creer lo rápido que fue',
  time: '6h',
  likes: 38
}, {
  name: 'Andrea Castillo',
  photo: 'https://randomuser.me/api/portraits/women/8.jpg',
  text: 'Justo lo que necesitaba!! 🔥',
  time: '7h',
  likes: 15
}, {
  name: 'Gabriela Moreno',
  photo: 'https://randomuser.me/api/portraits/women/14.jpg',
  text: 'Al principio dudé mucho porque ya compré otros cursos y nunca los terminé... pero esto es DIFERENTE. Es tan simple que no hay excusa. Ya voy en el capítulo 4 y todo tiene sentido',
  time: '8h',
  likes: 42,
  replies: [{
    name: 'Carolina Peña',
    photo: 'https://randomuser.me/api/portraits/women/22.jpg',
    text: 'Igual yo!! tengo como 3 cursos sin terminar jaja pero este sí lo acabé en 2 días',
    time: '7h',
    likes: 9
  }]
}, {
  name: 'Alejandra Guzmán',
  photo: 'https://randomuser.me/api/portraits/women/36.jpg',
  text: 'Mi primera venta fue a mi propia prima jajaja pero CUENTA 😂😂 ya van 3 ventas en total!!',
  time: '9h',
  likes: 61
}, {
  name: 'Paola Jiménez',
  photo: 'https://randomuser.me/api/portraits/women/41.jpg',
  text: 'Yo que pensaba que necesitaba laptop y saber diseñar... todo lo hice desde mi celular en la cama a las 11pm cuando los niños ya dormían 😴📱',
  time: '10h',
  likes: 33
}, {
  name: 'Natalia Reyes',
  photo: 'https://randomuser.me/api/portraits/women/55.jpg',
  text: 'Las portadas del bono están HERMOSAS. Mi PDF se ve super profesional y lo hice yo solita 🥹',
  time: '11h',
  likes: 27
}, {
  name: 'Mariana Torres',
  photo: 'https://randomuser.me/api/portraits/women/67.jpg',
  text: 'Alguien más lloró con su primera venta o solo yo? 😭💕',
  time: '12h',
  likes: 73,
  replies: [{
    name: 'Jimena Salazar',
    photo: 'https://randomuser.me/api/portraits/women/76.jpg',
    text: 'YOOOO 😭😭😭 literal grité y mi esposo pensó que me pasó algo jajajaja',
    time: '11h',
    likes: 18
  }]
}, {
  name: 'Ana Paula Vega',
  photo: 'https://randomuser.me/api/portraits/women/82.jpg',
  text: 'Lo que más me gustó es que no te venden humo. Es real, es simple, y funciona. Punto.',
  time: '13h',
  likes: 31
}, {
  name: 'Karla Domínguez',
  photo: 'https://randomuser.me/api/portraits/women/3.jpg',
  text: 'Hice mi PDF sobre recetas saludables para bebés y ya vendí 7 copias en mi grupo de mamás de WhatsApp 🍼✨',
  time: '14h',
  likes: 44
}, {
  name: 'Diana Ramírez',
  photo: 'https://randomuser.me/api/portraits/women/17.jpg',
  text: 'Increíble 👏👏',
  time: '15h',
  likes: 11
}, {
  name: 'Mónica Hernández',
  photo: 'https://randomuser.me/api/portraits/women/24.jpg',
  text: 'Tengo 2 hijos, trabajo medio tiempo y aún así pude terminar mi PDF en 5 días. Si yo pude, cualquiera puede. No es excusa el tiempo',
  time: '16h',
  likes: 52
}, {
  name: 'Laura Sánchez',
  photo: 'https://randomuser.me/api/portraits/women/31.jpg',
  text: 'El método 3P para elegir tema es GENIAL. Yo estaba super perdida y en 20 minutos ya sabía exactamente qué crear',
  time: '17h',
  likes: 26
}, {
  name: 'Patricia Ortiz',
  photo: 'https://randomuser.me/api/portraits/women/39.jpg',
  text: 'Valió cada centavo 💯',
  time: '18h',
  likes: 19
}, {
  name: 'Claudia Navarro',
  photo: 'https://randomuser.me/api/portraits/women/48.jpg',
  text: 'Mi mamá me dijo "eso no va a funcionar" y ayer le enseñé que ya llevo $45 dólares en ventas 😏 La cara que puso no tiene precio jajaja',
  time: '1d',
  likes: 89,
  replies: [{
    name: 'Verónica Cruz',
    photo: 'https://randomuser.me/api/portraits/women/56.jpg',
    text: 'JAJAJA la mejor venganza es el éxito 😂🔥',
    time: '22h',
    likes: 14
  }]
}, {
  name: 'Adriana Paredes',
  photo: 'https://randomuser.me/api/portraits/women/61.jpg',
  text: 'Yo no sabía NADA de productos digitales. Cero. Y ahora tengo un PDF publicado y vendiendo. Esto es una locura',
  time: '1d',
  likes: 37
}, {
  name: 'Lorena Aguilar',
  photo: 'https://randomuser.me/api/portraits/women/69.jpg',
  text: 'Los mensajes copy-paste del bono son ORO PURO. Copié, pegué en mis historias y me empezaron a escribir. Así de fácil',
  time: '1d',
  likes: 41
}, {
  name: 'Catalina Mejía',
  photo: 'https://randomuser.me/api/portraits/women/74.jpg',
  text: 'Estoy llorando de la emoción. Acabo de hacer mi primera venta a una desconocida que me encontró por Instagram 😭🙏',
  time: '1d',
  likes: 65
}, {
  name: 'Renata Díaz',
  photo: 'https://randomuser.me/api/portraits/women/79.jpg',
  text: 'Super recomendado para mamás que quieren empezar pero no saben por dónde 👌',
  time: '2d',
  likes: 22
}, {
  name: 'Ximena Fuentes',
  photo: 'https://randomuser.me/api/portraits/women/85.jpg',
  text: 'Gamma App es una maravilla!! Mi PDF quedó como si lo hubiera hecho un diseñador profesional y yo solo seguí los pasos de la guía 😍',
  time: '2d',
  likes: 35
}, {
  name: 'Paulina Rojas',
  photo: 'https://randomuser.me/api/portraits/women/91.jpg',
  text: 'Ya voy por mi SEGUNDO PDF 🚀🚀 el primero fue de organización del hogar y ahora estoy haciendo uno de presupuesto familiar',
  time: '2d',
  likes: 48,
  replies: [{
    name: 'Estefanía Luna',
    photo: 'https://randomuser.me/api/portraits/women/95.jpg',
    text: 'Wow ya el segundo?? Yo apenas voy terminando el primero jaja eres mi inspiración 💪',
    time: '1d',
    likes: 7
  }]
}, {
  name: 'Marisol Contreras',
  photo: 'https://randomuser.me/api/portraits/women/5.jpg',
  text: 'Chicas esto es REAL. No es otro curso que te deja igual. Yo ya recuperé lo que pagué x3 y apenas llevo una semana',
  time: '2d',
  likes: 54
}, {
  name: 'Jimena Salazar',
  photo: 'https://randomuser.me/api/portraits/women/76.jpg',
  text: 'Lo mejor es que puedes hacerlo a tu ritmo. Yo algunos días solo le dedicaba 30 minutos y aún así terminé rápido',
  time: '3d',
  likes: 20
}, {
  name: 'Verónica Cruz',
  photo: 'https://randomuser.me/api/portraits/women/56.jpg',
  text: 'Hice un PDF sobre rutinas de skincare coreano y ya vendí 12 copias 🧴✨ las chicas de mi grupo de belleza lo amaron',
  time: '3d',
  likes: 43
}, {
  name: 'Luciana Mendoza',
  photo: 'https://randomuser.me/api/portraits/women/19.jpg',
  text: 'UPDATE: me animé a publicar y ya tengo 2 ventas!!! 😱 Gracias Isabella por el empujón y gracias Mamá Digital por la guía 🙏💕',
  time: '3d',
  likes: 58
}, {
  name: 'Carolina Peña',
  photo: 'https://randomuser.me/api/portraits/women/22.jpg',
  text: 'El checklist de entrega del bono 3 es increíble. Mis clientas me dicen que todo se siente muy profesional 😊',
  time: '3d',
  likes: 25
}, {
  name: 'Estefanía Luna',
  photo: 'https://randomuser.me/api/portraits/women/95.jpg',
  text: 'Nunca pensé que YO podría vender algo digital. Soy ama de casa y sentía que no tenía nada que ofrecer. Este programa me demostró que estaba equivocada 🥹💪',
  time: '4d',
  likes: 71
}, {
  name: 'Valentina Ríos',
  photo: 'https://randomuser.me/api/portraits/women/28.jpg',
  text: 'TERMINÉ MI PDF CHICASSS 🎉🎉🎉🎉 es sobre meal prep para mamás ocupadas. Deseenme suerte que mañana lo lanzo!!',
  time: '4d',
  likes: 46,
  replies: [{
    name: 'María José Herrera',
    photo: 'https://randomuser.me/api/portraits/women/12.jpg',
    text: 'Éxitooo!! 🙌 ya verás que te va increíble, el tema está buenísimo',
    time: '3d',
    likes: 11
  }]
}];
function FacebookLikeIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 16 16" fill="currentColor" data-id="element-492">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-2.5a.5.5 0 0 0-1 0v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 0 0-1h-1v-1z" data-id="element-493" />
    </svg>;
}
export function SocialProof() {
  const [showAll, setShowAll] = useState(false);
  const visibleComments = showAll ? comments : comments.slice(0, 8);
  return <Section className="bg-[#F0F2F5]" data-id="element-494">
      {/* Section Header */}
      <div className="text-center mb-8" data-id="element-495">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-496">
          Lo Que Dicen Nuestras Mamás Digitales
        </h2>
        <p className="text-gray-500" data-id="element-497">Comentarios reales de nuestra comunidad</p>
      </div>

      {/* Facebook Post Card */}
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-498">
        {/* Post Header */}
        <div className="p-3 pb-0" data-id="element-499">
          <div className="flex items-center gap-2" data-id="element-500">
            <div className="w-10 h-10 rounded-full bg-brand-pink flex items-center justify-center text-white font-bold text-sm flex-shrink-0" data-id="element-501">
              MD
            </div>
            <div className="flex-1 min-w-0" data-id="element-502">
              <div className="flex items-center gap-1" data-id="element-503">
                <span className="font-semibold text-[15px] text-gray-900" data-id="element-504">
                  Mamá Digital 2.0
                </span>
                <svg className="w-3.5 h-3.5 text-[#1877F2]" viewBox="0 0 16 16" fill="currentColor" data-id="element-505">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" data-id="element-506" />
                </svg>
              </div>
              <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-507">
                <span data-id="element-508">2d</span>
                <span data-id="element-509">·</span>
                <svg className="w-3 h-3" viewBox="0 0 16 16" fill="currentColor" data-id="element-510">
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM.5 8a7.5 7.5 0 1 1 15 0A7.5 7.5 0 0 1 .5 8z" data-id="element-511" />
                  <path d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z" data-id="element-512" />
                </svg>
              </div>
            </div>
          </div>

          {/* Post Text */}
          <p className="mt-3 text-[15px] text-gray-900 leading-snug" data-id="element-513">
            ¿Quién ya descargó la guía? 🙌 Cuéntanos cómo te fue! Queremos leer
            sus historias 💕
          </p>
        </div>

        {/* Post Image */}
        <div className="mt-3" data-id="element-514">
          <img src="https://cdn.magicpatterns.com/uploads/kTpbPJ8qdeYZyuJU8TJZeK/heylloyd-image-1768698487050.png" alt="Mamá Digital 2.0" className="w-full h-auto" data-id="element-515" />
        </div>

        {/* Engagement Counts */}
        <div className="px-4 py-2.5 flex items-center justify-between text-[13px] text-gray-500" data-id="element-516">
          <div className="flex items-center gap-1" data-id="element-517">
            <div className="flex -space-x-1" data-id="element-518">
              <span className="w-[18px] h-[18px] rounded-full bg-[#1877F2] flex items-center justify-center" data-id="element-519">
                <ThumbsUp className="w-2.5 h-2.5 text-white" data-id="element-520" />
              </span>
              <span className="w-[18px] h-[18px] rounded-full bg-red-500 flex items-center justify-center text-[8px]" data-id="element-521">
                ❤️
              </span>
            </div>
            <span className="ml-1" data-id="element-522">234</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-523">
            <span data-id="element-524">32 comentarios</span>
            <span data-id="element-525">12 compartidos</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mx-4 py-1 border-t border-b border-gray-200 flex" data-id="element-526">
          <button className="flex-1 flex items-center justify-center gap-2 py-1.5 rounded-md text-[15px] font-semibold text-gray-600" data-id="element-527">
            <ThumbsUp className="w-5 h-5" data-id="element-528" />
            <span className="text-sm" data-id="element-529">Me gusta</span>
          </button>
          <button className="flex-1 flex items-center justify-center gap-2 py-1.5 rounded-md text-[15px] font-semibold text-gray-600" data-id="element-530">
            <MessageCircle className="w-5 h-5" data-id="element-531" />
            <span className="text-sm" data-id="element-532">Comentar</span>
          </button>
          <button className="flex-1 flex items-center justify-center gap-2 py-1.5 rounded-md text-[15px] font-semibold text-gray-600" data-id="element-533">
            <Share2 className="w-5 h-5" data-id="element-534" />
            <span className="text-sm" data-id="element-535">Compartir</span>
          </button>
        </div>

        {/* Comments Section */}
        <div className="px-4 py-3" data-id="element-536">
          {/* Show more button at top */}
          {!showAll && <button onClick={() => setShowAll(true)} className="text-[15px] font-semibold text-gray-500 mb-3 flex items-center gap-1" data-id="element-537">
              Ver los 32 comentarios
              <ChevronDown className="w-4 h-4" data-id="element-538" />
            </button>}

          {/* Comments List */}
          <div className="space-y-3" data-id="element-539">
            {visibleComments.map((comment, index) => <div key={index} data-id="element-540">
                {/* Main Comment */}
                <div className="flex gap-2" data-id="element-541">
                  <img src={comment.photo} alt={comment.name} className="w-8 h-8 rounded-full object-cover flex-shrink-0 mt-0.5" data-id="element-542" />
                  <div className="flex-1 min-w-0" data-id="element-543">
                    <div className="bg-[#F0F2F5] rounded-2xl px-3 py-2 inline-block max-w-full" data-id="element-544">
                      <span className="font-semibold text-[13px] text-gray-900 block" data-id="element-545">
                        {comment.name}
                      </span>
                      <span className="text-[15px] text-gray-900 leading-snug" data-id="element-546">
                        {comment.text}
                      </span>
                    </div>
                    <div className="flex items-center gap-3 mt-0.5 ml-3 text-xs" data-id="element-547">
                      <span className="text-gray-500" data-id="element-548">{comment.time}</span>
                      <button className="font-semibold text-gray-500" data-id="element-549">
                        Me gusta
                      </button>
                      <button className="font-semibold text-gray-500" data-id="element-550">
                        Responder
                      </button>
                      {comment.likes && comment.likes > 0 && <span className="flex items-center gap-0.5 ml-auto text-gray-500" data-id="element-551">
                          <span className="w-4 h-4 rounded-full bg-[#1877F2] flex items-center justify-center" data-id="element-552">
                            <ThumbsUp className="w-2.5 h-2.5 text-white" data-id="element-553" />
                          </span>
                          {comment.likes}
                        </span>}
                    </div>

                    {/* Replies */}
                    {comment.replies && comment.replies.length > 0 && <div className="mt-2 space-y-2 ml-2" data-id="element-554">
                        {comment.replies.map((reply, rIndex) => <div key={rIndex} className="flex gap-2" data-id="element-555">
                            <img src={reply.photo} alt={reply.name} className="w-6 h-6 rounded-full object-cover flex-shrink-0 mt-0.5" data-id="element-556" />
                            <div className="flex-1 min-w-0" data-id="element-557">
                              <div className="bg-[#F0F2F5] rounded-2xl px-3 py-2 inline-block max-w-full" data-id="element-558">
                                <span className="font-semibold text-[13px] text-gray-900 block" data-id="element-559">
                                  {reply.name}
                                </span>
                                <span className="text-[14px] text-gray-900 leading-snug" data-id="element-560">
                                  {reply.text}
                                </span>
                              </div>
                              <div className="flex items-center gap-3 mt-0.5 ml-3 text-xs" data-id="element-561">
                                <span className="text-gray-500" data-id="element-562">
                                  {reply.time}
                                </span>
                                <button className="font-semibold text-gray-500" data-id="element-563">
                                  Me gusta
                                </button>
                                <button className="font-semibold text-gray-500" data-id="element-564">
                                  Responder
                                </button>
                                {reply.likes && reply.likes > 0 && <span className="flex items-center gap-0.5 ml-auto text-gray-500" data-id="element-565">
                                    <span className="w-4 h-4 rounded-full bg-[#1877F2] flex items-center justify-center" data-id="element-566">
                                      <ThumbsUp className="w-2.5 h-2.5 text-white" data-id="element-567" />
                                    </span>
                                    {reply.likes}
                                  </span>}
                              </div>
                            </div>
                          </div>)}
                      </div>}
                  </div>
                </div>
              </div>)}
          </div>

          {/* Show more / Show less */}
          {!showAll && <button onClick={() => setShowAll(true)} className="mt-4 text-[15px] font-semibold text-gray-500 flex items-center gap-1" data-id="element-568">
              Ver más comentarios
              <ChevronDown className="w-4 h-4" data-id="element-569" />
            </button>}
          {showAll && <button onClick={() => setShowAll(false)} className="mt-4 text-[15px] font-semibold text-gray-500 flex items-center gap-1" data-id="element-570">
              <ChevronDown className="w-4 h-4 rotate-180" data-id="element-571" />
              Ocultar comentarios
            </button>}

          {/* Comment Input (decorative) */}
          <div className="flex items-center gap-2 mt-4 pt-3 border-t border-gray-100" data-id="element-572">
            <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0" data-id="element-573" />
            <div className="flex-1 bg-[#F0F2F5] rounded-full px-4 py-2 text-[15px] text-gray-500" data-id="element-574">
              Escribe un comentario...
            </div>
          </div>
        </div>
      </div>
    </Section>;
}